/**
 * Different types of members that can be in a dialog.
 */
export var DialogMemberType;
(function (DialogMemberType) {
    DialogMemberType[DialogMemberType["Client"] = 1] = "Client";
    DialogMemberType[DialogMemberType["Admin"] = 2] = "Admin";
    DialogMemberType[DialogMemberType["Bot"] = 3] = "Bot";
})(DialogMemberType || (DialogMemberType = {}));
//# sourceMappingURL=memberType.js.map